@if (uiBlock) {
  @if (isUnavailableType) {
    <div class="rounded-lg border border-yellow-600 bg-yellow-50">
      <div class="flex items-center justify-between gap-4 p-4">
        <div class="flex items-start gap-4">
          <fa-icon [icon]="faCircleExclamation" class="text-yellow-600 text-svg-16 w-4 h-4 shrink-0 -mt-0.5"></fa-icon>
          <!-- Interpolation direkt am Tag: bei whitespace-pre-wrap blieben sonst Einrückung und Zeilenumbruch
               als führendes Leerzeichen stehen. -->
          <p
            class="m-0 text-[13px] not-italic text-gray-900 whitespace-pre-wrap">{{ uiBlock.unavailableText?.trim() || 'Der gewünschte Inhalt ist aktuell nicht verfügbar.' }}</p>
        </div>
        @if (shouldShowUnavailableFeatureRequest) {
          <bic-button
            (onClick)="onUnavailableFeatureRequestClick()"
            [disabled]="isUnavailableFeatureRequestSubmitting || isFeatureRequestSent || isFeatureRequestOpen"
            [loading]="isUnavailableFeatureRequestSubmitting && !isFeatureRequestOpen"
            buttonType="white"
            class="shrink-0">
            {{ isFeatureRequestSent ? 'Angefragt' : 'Feature anfragen' }}
          </bic-button>
        }
      </div>
      <!-- Vorschlag (vom Modell oder von chatBIC nachträglich erzeugt): erst nach „Senden" geht die Anfrage
           raus; vorher bearbeitbar. -->
      @if (shouldShowUnavailableFeatureRequest && isFeatureRequestOpen) {
        <div class="flex flex-col gap-3 border-t border-yellow-600 p-4">
          @if (isFeatureProposalLoading) {
            <p class="m-0 text-[12px] not-italic text-gray-700">chatBIC erstellt einen Vorschlag …</p>
          }
          @if (featureProposalFailed) {
            <p class="m-0 text-[12px] not-italic text-gray-700">
              Es konnte kein Vorschlag erstellt werden. Bitte beschreibe deinen Wunsch selbst.
            </p>
          }
          <bic-input [(value)]="featureDraft.title"
                     [disabled]="isUnavailableFeatureRequestSubmitting || isFeatureProposalLoading"
                     label="Titel" placeholder="Kurzer Titel"></bic-input>
          <bic-textarea [(value)]="featureDraft.problem"
                        [disabled]="isUnavailableFeatureRequestSubmitting || isFeatureProposalLoading"
                        [rows]="3" label="Problem" placeholder="Was geht heute nicht?"></bic-textarea>
          <bic-textarea [(value)]="featureDraft.desiredBehavior"
                        [disabled]="isUnavailableFeatureRequestSubmitting || isFeatureProposalLoading"
                        [rows]="3" label="Gewünschtes Verhalten"
                        placeholder="Wie soll es sich verhalten?"></bic-textarea>
          <bic-select [(value)]="featureDraft.area"
                      [disabled]="isUnavailableFeatureRequestSubmitting || isFeatureProposalLoading"
                      label="Bereich" placeholder="Bereich auswählen">
            @for (area of featureAreaOptions; track area) {
              <bic-dropdown-element [value]="area">{{ area }}</bic-dropdown-element>
            }
          </bic-select>
          @if (sendsChatHistory) {
            <label class="flex cursor-pointer items-start gap-2">
              <input type="checkbox" class="mt-0.5 w-4 h-4 rounded border-gray-300 text-teal-500 focus:ring-teal-500"
                     [checked]="includeChatHistory"
                     (change)="includeChatHistory = $any($event.target).checked"
                     [disabled]="isUnavailableFeatureRequestSubmitting">
              <span class="flex flex-col gap-0.5">
                <span class="text-[13px] not-italic text-gray-900">Chatverlauf mitsenden</span>
                <span class="text-[12px] not-italic text-gray-700">
                  Die letzten Nachrichten dieses Chats werden zur besseren Einordnung mitgesendet.
                </span>
              </span>
            </label>
          }
          <div class="flex flex-row justify-end gap-2">
            <bic-button (onClick)="onFeatureRequestCancel()" [disabled]="isUnavailableFeatureRequestSubmitting"
                        buttonType="white">Abbrechen
            </bic-button>
            <bic-button (onClick)="onFeatureRequestConfirm()"
                        [disabled]="!canSendFeatureDraft || isUnavailableFeatureRequestSubmitting"
                        [loading]="isUnavailableFeatureRequestSubmitting"
                        buttonType="primary">Senden
            </bic-button>
          </div>
        </div>
      }
    </div>
  } @else {
    <div class="flex flex-col gap-0 rounded-xl bg-white shadow-full">
      @if (uiBlock.question && !isSummaryType) {
        <p class="m-0 px-4 py-3 text-[14px] font-medium not-italic text-gray-900">{{ uiBlock.question }}</p>
      }

      @if (isSummaryType && (summaryFields.length > 0 || uiBlock.summary)) {
        <div class="flex items-center gap-2 px-4 py-3">
          <fa-icon [icon]="faScrewdriverWrench"
                   class="summary-row-icon inline-flex h-4 w-4 shrink-0 items-center justify-center leading-none text-gray-900"></fa-icon>
          <markdown [data]="summaryHeaderTitle" [inline]="true"
                    class="m-0 text-[14px] font-medium leading-4 not-italic text-gray-900"></markdown>
        </div>
        <div class="border-t border-gray-200 px-4 py-3">
          @if (summaryFields.length > 0) {
            <div class="flex flex-col gap-4">
              @for (field of summaryFields; track trackBySummaryField($index, field)) {
                <div class="flex flex-col gap-1">
                  <div class="flex items-center gap-2">
                    <fa-icon [icon]="getSummaryFieldIcon(field.title)"
                             class="summary-row-icon inline-flex h-4 w-4 shrink-0 items-center justify-center leading-none text-gray-900"></fa-icon>
                    <markdown [data]="field.title" [inline]="true"
                              class="m-0 text-[13px] font-medium leading-4 not-italic text-gray-900"></markdown>
                  </div>
                  <ul class="m-0 list-disc pl-6 text-[13px] not-italic text-gray-900">
                    @for (bulletPoint of field.bulletPoints; track trackByBulletPoint($index, bulletPoint)) {
                      <li>
                        <markdown [data]="bulletPoint" [inline]="true"></markdown>
                      </li>
                    }
                  </ul>
                </div>
              }
            </div>
          } @else if (uiBlock.summary) {
            <markdown [data]="summaryMarkdown"
                      class="chat-markdown m-0 text-[13px] not-italic text-gray-900"></markdown>
          }
        </div>
      }

      <!-- Auch am summary-Block: das Modell hängt „myCheck anlegen" / „Details anpassen" gern direkt
           an die Übersicht. Nur bei type 'options' gerendert, war die Bestätigung nie zu sehen. -->
      @if (hasOptions && (isOptionsType || isSummaryType)) {
        <div
          [ngClass]="{'border-t border-gray-200': uiBlock.question || uiBlock.summary}"
          class="flex flex-col p-2">
          @if (isSingleUploadAction) {
            <bic-button
              (onClick)="onOptionClick(filteredOptions[0])"
              buttonType="white"
              class="w-fit">
              {{ filteredOptions[0].label }}
            </bic-button>
          }
          @for (option of filteredOptions; track trackByValue($index, option); let index = $index) {
            @if (!isSingleUploadAction) {
              <button
                (click)="onOptionClick(option)"
                class="group flex w-full cursor-pointer items-center gap-4 rounded-[10px] border-0 bg-white p-2 text-left transition-colors duration-100 hover:bg-gray-100"
                type="button">
                <span
                  [ngClass]="isSelected(option) ? 'bg-green-500 text-white' : 'bg-gray-100 text-gray-500'"
                  class="flex h-5 w-5 shrink-0 items-center justify-center rounded-md text-xs">
                  {{ index + 1 }}
                </span>
                <span
                  [ngClass]="isSelected(option) ? 'text-green-500' : 'text-gray-900'"
                  class="text-[14px] font-normal not-italic">
                  {{ option.label }}
                </span>
              </button>
            }
          }
        </div>
      }
    </div>
  }
}
